import BaseResource from './base-resource';
import JsonApiReference from './jsonapi-reference';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';
import SiteResource from './site-resource';

export default class EpxUnitResource extends BaseResource {
  name: string;
  serial: string;
  unitType: string;
  group: SiteResource;

  constructor(init?: Partial<EpxUnitResource>) {
    super(init, 'epx-units');
    this.initialize(init);
  }
}



// WEBPACK FOOTER //
// ./common/models/epx-unit-resource.ts